export const INCOME_CATS = [["employment", "Regular employment income"], ["overtime", "Overtime"], ["paid_duty", "Paid duty"], ["bonuses", "Bonuses"], ["court", "Court pay"], ["callback", "Callback pay"], ["other_earnings", "Other work earnings"], ["side_business", "Side business"], ["rental", "Rental income"], ["other_income", "Other income"]];
export const EXPENSE_CATS = [["mortgage_rent", "Mortgage or rent"], ["car_payments", "Car payments"], ["car_insurance", "Car insurance"], ["home_insurance", "Home insurance"], ["utilities", "Utilities"], ["gas_electricity", "Gas & electricity"], ["phone_internet", "Internet & telephone"], ["groceries", "Groceries"], ["fuel", "Fuel / transit"], ["childcare", "Childcare"], ["credit_cards", "Credit card payments"], ["loans", "Loans & lines of credit"], ["entertainment", "Entertainment"], ["other_expenses", "Other expenses"]];
export const HOURS_CATS = new Set(["overtime", "paid_duty", "court", "callback"]);
export const FREQS = [["monthly", "Monthly"], ["weekly", "Weekly"], ["biweekly", "Every 2 weeks"], ["semi_monthly", "Twice a month"], ["quarterly", "Quarterly"], ["annual", "Yearly"]];
export const SOURCE_LABEL = { tracker: "Earnings tracker", mortgage: "Saved mortgage", vehicle: "Saved vehicle loan", debts: "Debt planner", recurring: "Recurring expenses", manual: "Manual" };

const catMap = Object.fromEntries([...INCOME_CATS, ...EXPENSE_CATS]);
export const catLabel = (k) => catMap[k] || k;
export const newId = () => Math.random().toString(36).slice(2, 12);

export const defaultRate = (rates, cat) => {
  const opts = rates?.[cat] || [];
  const o = opts.find((x) => x.label.includes("your default")) || opts[0];
  return { method: "hours", hours: "", rate: o?.rate ?? "", rate_label: o?.label ?? "" };
};

export const manualLine = (section, category, rates = null) => ({
  id: newId(), section, category, label: catLabel(category), amount: "", source: "manual",
  calc: rates ? defaultRate(rates, category) : null,
});

/** Merge fresh imports into existing lines by source_key: no duplicates, overrides and manual lines kept. */
export function mergeImports(lines, auto) {
  const byKey = new Map(auto.map((a) => [a.source_key, a]));
  const seen = new Set();
  const out = [];
  lines.forEach((l) => {
    const a = l.source !== "manual" ? byKey.get(l.source_key) : null;
    if (l.source === "manual") return out.push(l);
    if (!a || seen.has(a.source_key)) return l.overridden && !a ? out.push({ ...l, imported_amount: 0, meta: "No longer in your records for this month" }) : null;
    seen.add(a.source_key);
    out.push(l.overridden ? { ...l, imported_amount: a.amount, label: a.label } : { ...a, id: l.id, excluded: l.excluded });
  });
  auto.forEach((a) => { if (!seen.has(a.source_key)) out.push({ ...a, id: newId() }); });
  return out;
}

export function importsChanged(lines, auto) {
  const byKey = new Map(lines.filter((l) => l.source !== "manual").map((l) => [l.source_key, l]));
  const autoKeys = new Set(auto.map((a) => a.source_key));
  const removed = [...byKey.values()].some((l) => !autoKeys.has(l.source_key) && Number(l.imported_amount) !== 0);
  return removed || auto.some((a) => { const l = byKey.get(a.source_key); return !l || Number(l.imported_amount) !== Number(a.amount); });
}

export const toPayload = (lines) => lines.map((l) => ({ ...l, amount: Number(l.amount) || 0 }));
